import { useState, useEffect } from "react";
import { X } from "lucide-react";

interface Props {
  onVisibilityChange?: (visible: boolean) => void;
}

const DowntimeBanner = ({ onVisibilityChange }: Props) => {
  const [visible, setVisible] = useState(false);
  const [formattedTime, setFormattedTime] = useState("");

  useEffect(() => {
    const raw = import.meta.env.VITE_DOWNTIME_UNTIL;
    if (!raw) return;

    const downtimeDate = new Date(raw);
    if (isNaN(downtimeDate.getTime()) || downtimeDate <= new Date()) return;

    setFormattedTime(
      downtimeDate.toLocaleString(undefined, {
        month: "short",
        day: "numeric",
        hour: "numeric",
        minute: "2-digit",
        timeZoneName: "short",
      })
    );
    setVisible(true);
    onVisibilityChange?.(true);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!visible) return null;

  return (
    <div className="fixed top-0 left-0 right-0 z-[100] h-10 bg-amber-500 text-black text-sm font-medium px-4 flex items-center justify-center gap-2">
      <span className="truncate">
        Scheduled maintenance — service will be restored by{" "}
        <strong>{formattedTime}</strong>. Some features may be unavailable.
      </span>
    </div>
  );
};

export default DowntimeBanner;
